import api from "./api";




const inquiereCompanyTypes = async () => {

	const apiPath = `/company/inquirecompanytypes`;
	console.log("inquirecompanytypes");
	const response = await api
		.get(apiPath);
	return response;
};

const inquiereCompanies = async (param) => {
	let _param = encodeURIComponent(param);

	const apiPath = `/company/inquirecompanies?companyName=${_param}`;
	console.log("inquirecompanies");
	const response = await api
		.get(apiPath);
	return response;
};

const inquireFeaturedMuseums = async () => {

	const apiPath = `/company/inquirefeaturedmuseums`;
	console.log("inquirefeaturedmuseums");
	const response = await api
		.get(apiPath);
	return response;
};


const CompanyService = {
	inquiereCompanyTypes,
	inquiereCompanies,
	inquireFeaturedMuseums
};

export default CompanyService;
